/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class IspsChangeApprovalRequestTO {
    'approved'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "approved",
            "baseName": "approved",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return IspsChangeApprovalRequestTO.attributeTypeMap;
    }

    public constructor() {
    }
}

